import {
  SHARE_ON_FACEBOOK_APP_ID,
  SKY_FOUNDATION_PARSELY_API_KEY,
  SKY_FOUNDATION_STATIC_DOMAIN,
  SKY_FOUNDATION_VIDEO_PLAYLIST_BASE_URL,
} from '../../utils/constants';

const config = require('config');

const DEFAULT_LOGIN_URL = 'https://www.sky.it/login';
const DEFAULT_LOGOUT_URL = 'https://test.cerebro-platform.sky.it/cronus/token/reset';
const DEFAULT_PERSONALIZE_URL = 'https://www.sky.it/account';
const DEFAULT_REFRESH_HP_MINUTES = 8;

const DEFAULT_PREMIUM_CUSTOMER_PORTAL_URL = 'https://stage.subhub.sky.it/bff/users/customerPortalUrl';
const DEFAULT_PREMIUM_PRICING_TABLE_URL = 'https://stage.subhub.sky.it/bff/users/customerPricingTable';
const DEFAULT_PREMIUM_NEWSLETTERS_URL = 'https://stage.subhub.sky.it/bff/users/newsletters';

const getSetting = (key, defaultValue) => window.SkyFoundationSettings?.[key] || defaultValue;

const skyFoundationSettings = {
  getFoundationSettings: () => window.SkyFoundationSettings || config.skyFoundationDefaultSettings,
  getStaticDomain: () => getSetting('staticDomain', SKY_FOUNDATION_STATIC_DOMAIN),
  getPlaylistBaseUrl: () => getSetting('videoPlaylistBaseUrl', SKY_FOUNDATION_VIDEO_PLAYLIST_BASE_URL),
  getParselyApiKey: () => getSetting('parselyApyKey', SKY_FOUNDATION_PARSELY_API_KEY),
  getShareOnFacebookAppId: () => getSetting('shareOnFacebookAppId', SHARE_ON_FACEBOOK_APP_ID),
  getParselyCookieDomain: () => getSetting('parselyCookieDomain', window.location.hostname),
  getLazyLoadedHomepage: () => Boolean(getSetting('lazyLoaded')),
  getTitleHomepage: () => getSetting('lazyLoadedHpTitle', undefined),
  getTokenManagerBaseUrl: () => getSetting('tokenManagerBaseUrl', ''),
  getPersonalizationApi: () => {
    const settings = getSetting('personalizationApi', {});
    return {
      ...settings,
      apiKey: settings.apikey,
    };
  },
  getLoginBaseUrl: () => getSetting('loginUrl', DEFAULT_LOGIN_URL),
  getLogoutBaseUrl: () => getSetting('logoutUrl', DEFAULT_LOGOUT_URL),
  getPersonalizeUrl: () => getSetting('personalizeUrl', DEFAULT_PERSONALIZE_URL),
  getRefreshHpMinutes: () => getSetting('refreshHpMinutes', DEFAULT_REFRESH_HP_MINUTES),
  getDaiOff: () => getSetting('daiOff', undefined),
  getAudioOnArticleHeroPlayer: () => getSetting('audioOnArticleHeroPlayer'),
  getPremiumCustomerPortalURL: () => getSetting('premiumCustomerPortalURL', DEFAULT_PREMIUM_CUSTOMER_PORTAL_URL),
  getPremiumPricingTableURL: () => getSetting('premiumPricingTableURL', DEFAULT_PREMIUM_PRICING_TABLE_URL),
  getPremiumNewslettersURL: () => getSetting('premiumNewslettersURL', DEFAULT_PREMIUM_NEWSLETTERS_URL),
  getLocalNavUrl: () => getSetting('localNavUrl', ''),
};

export { skyFoundationSettings };
